import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';
import { ContactsDisclaimer } from '../ContactsDisclaimer';
import * as styles from './SidebarContactsInfo.css';

interface ISidebarContactsInfoProps {
  phone: string;
}

export const SidebarContactsInfo: React.FC<ISidebarContactsInfoProps> = ({ phone }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['phone']}>
        <UIHeading2>{phone}</UIHeading2>
      </div>
      <ContactsDisclaimer />
    </div>
  );
};
